

let timeOutClose = null;

export default (props, inject) => {
  const openErrorNotification = function (message = "Возникла ошибка\nпопробуйте перезагрузить страницу", configuration = {}) {
    props.store.commit("custom-notification/openErrorNotification", {
      message,
      configuration
    });

    const duration = configuration?.duration || 4000;
    timeOutClose = setTimeout(() => {
      closeCustomNotification();
    }, duration);
  }
  const openCustomNotification = function (message, configuration = {}) {
    props.store.commit("custom-notification/openCustomNotification", {
      message,
      params: configuration
    });

    const duration = configuration?.duration || 4000;
    timeOutClose = setTimeout(() => {
      closeCustomNotification();
    }, duration);
  }
  const closeCustomNotification = function () {
    clearTimeout(timeOutClose);

    props.store.commit("custom-notification/closeErrorNotification");
  }

  inject('customNotification', {
    error: openErrorNotification,
    custom: openCustomNotification,


    close: closeCustomNotification
  })
}
